/**
 * OMFE Data Access Layer
 *
 * Provides:
 * - store
 * - config manager
 * - data manager
 * - storage (localStorage and sessionStorage)
 * - jsonp
 * - webapi (new)
 * - vendors
 */

export { configConst, setConfig } from './config-manager';
export { storeConst, getReducersFor, addReducer, getMiddlewares, addMiddleware, addStorePart, store } from './store';
export { storageConst, saveLocalItem, saveSessionItem, removeItem } from './storage';
export { jsonpConst, jsonpCall, jsonpSubscribe, jsonpUnsubscribe } from './jsonp';
export { api, onTx, onRx } from './webapi';
export { moment, userTimezone } from './vendors';

export { DataManager, dataConst } from './data-manager';



// WEBPACK FOOTER //
// ./src/OMFECore/index.js